import styled from "@emotion/styled";

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.black};

  width: 100%;
  position: absolute;

  height: calc(100vh - 160px);

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMin}) {
    height: calc(100vh - 140px);
  }
  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    height: calc(100vh - 180px);
  }
`;

export const Title = styled.h1`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.colors.white};
  font-size: 32px;
  font-weight: 600;
  line-height: 1.05;

  ,
  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 88px;
  }
`;
